module.exports = { "default": require("core-js/library/fn/object/set-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/_babel-runtime@6.23.0@babel-runtime/core-js/object/set-prototype-of.js
 ** module id = 377
 ** module chunks = 0 1
 **/